import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var CurrentUser = require("lib/account/CurrentUser");

@connect(
	(state, props) => {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}

		return {
			prefs
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
		onChange: (prefsUpdate, message) => {
			
			// RESETING ALL STUDENT LISTS
			var resetStudentLists = false

			if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
				resetStudentLists = true
			} 

			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				resetStudentLists: resetStudentLists,
				update: prefsUpdate
			}))
		},

	})
)

@providePopulateData({waitForLoad:true})
class ClassShelfPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("ClassShelfPreference");
	}

	onOptionChange(which) {
		if (which == "hide") {
			var prefsHash = { display_class_shelf: false, answers_on_class_shelf: false };
		} else if (which == "reviewsOnly") {
			var prefsHash = { display_class_shelf: true, answers_on_class_shelf: false };
		} else if (which == "both") {
			var prefsHash = { display_class_shelf: true, answers_on_class_shelf: true };
		}

		this.props.onChange(prefsHash, "You successfully changed the Class Shelf display setting.");
	}

	render() {
		return (
			<div className="newsfeedSettingContainer">
				<p>
					On the <i>Class Shelf</i>, students can see their classmates' book <em>Reviews </em>
					and, optionally, <em>Practice Questions</em>.
				</p>
				<label>
					<input type="radio" onChange={ this.onOptionChange.bind(this, "hide") }
						checked={ !this.props.prefs.display_class_shelf } />
					Hide Class Shelf
				</label><br />
				<label>
					<input type="radio" onChange={ this.onOptionChange.bind(this, "reviewsOnly") }
						checked={ this.props.prefs.display_class_shelf && !this.props.prefs.answers_on_class_shelf } />
					Show Class Shelf with book reviews only
				</label>
				<label>
					<input type="radio" onChange={ this.onOptionChange.bind(this, "both") }
						checked={ this.props.prefs.display_class_shelf && this.props.prefs.answers_on_class_shelf } />
					Show Class Shelf with book reviews and practice questions
				</label>
			</div>
		)
	}
}


ClassShelfPreference.WrappedComponent.propTypes = StrictPropTypes({
	prefs: PropTypes.object.isRequired,
	populateData: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
});

module.exports = ClassShelfPreference;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/ClassShelfPreference.js